// extracted by css-extract-rspack-plugin
export default {"empty":"b1gAhdj5xb0zUK26","team":"WraTkVVP7iQ7RFxi","teamName":"kEavkdi1STcT6shS","chevron":"fa_1a8TZACI9nZUF","hidden":"cDymNUMc6ZMD7OCq","more":"Ke2_ogxrK5kDUZPl"};